import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DatasetCheckScreen } from "pages/gpt/components/chatContent/components/DatasetCheckScreen";
import { DatasetValidationContext } from "providers/DatasetValidationProvider";
import { useContext } from "react";
import { useSelector } from "react-redux";

export const ValidationScreenPopup = () => {
  const {
    onCloseValidationScreen,
    validationStatus: { isOpenValidationScreen, dataset, data: validationData },
    setResponse,
    response,
    socketLoading,
  } = useContext(DatasetValidationContext);

  const { dataset_id: id } = useSelector((state) => state.chatsReducer.activeChat);

  const dataset_id = dataset?.id || id;

  return (
    <Dialog
      open={isOpenValidationScreen}
      onClose={onCloseValidationScreen}
      maxWidth="xlg"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          height: "calc(100svh - 68px)",
          maxWidth: "1350px",
        },
      }}
    >
      <DialogTitle sx={{ fontSize: "26px", fontWeight: 500, p: "34px 24px 24px" }}>
        Dataset Validation
      </DialogTitle>
      <IconButton onClick={onCloseValidationScreen} sx={{ position: "absolute", right: "14px", top: "22px" }}>
        <CloseIcon sx={{ width: "30px", height: "30px" }} />
      </IconButton>
      <DialogContent sx={{ mb: "34px", p: "0 24px 0" }}>
        <DatasetCheckScreen
          show={isOpenValidationScreen}
          dataset={dataset}
          validationData={dataset_id === response?.dataset_id ? validationData : null}
          onSuccessValidationRefresh={() => {
            if (dataset_id === response?.dataset_id) {
              setResponse(null);
            }
          }}
          datasetLoading={dataset_id === response?.dataset_id ? socketLoading : false}
        />
      </DialogContent>
    </Dialog>
  );
};
